"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorDetails = void 0;
function getErrorDetails(error) {
    if (!error)
        return;
    const respError = error;
    const status = respError.status || respError.response?.status;
    const error_class = error?.constructor?.name;
    const code = respError.code || respError.response?.data?.code;
    const message = [
        respError.name || respError.constructor?.name,
        respError.message,
        respError.response?.statusText && !respError.message.includes(respError.response?.statusText)
            ? respError.response?.statusText
            : undefined,
        respError?.response?.data?.message,
        respError?.response?.data?.errors?.[0]?.message
    ]
        .filter(Boolean)
        .join('; ');
    return { status, code: code?.toString(), message, class: error_class };
}
exports.getErrorDetails = getErrorDetails;
//# sourceMappingURL=ResponseError.js.map